import { Box, MenuItem, Modal, Select, Table, TableCell, TableRow, Tooltip } from '@mui/material';
import { LogoGenerator } from '../../components/LogoGenerator';
import { useEffect, useState } from 'react';
import { OddsHistoryGraph } from '../evscreen/EvScreenTable/OddsHistoryGraph';
import { getSportsbookDisplayName } from '../../utils/sportsbookAliases';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';

export const BetActionsOverlay = (props) => {
	const { isSpread, isHomeTeamNegativeSpread, linkOver, linkUnder, betPriceOver, betPriceUnder, sportsbook, outcome_id_normalized, sport, sportsbooks } = props;

	const { getAccessTokenSilently } = useAuth0();
	const [isHistoryOpen, setIsHistoryOpen] = useState(false);
	const [oddsHistories, setOddsHistories] = useState();
	const [selectedTimeRange, setSelectedTimeRange] = useState('all');
	const [selectedSportsbooks, setSelectedSportsbooks] = useState([sportsbook]);

	let spreadOver = isHomeTeamNegativeSpread ? 'bet_price_over_negative': 'bet_price_over_positive'
	let spreadUnder = isHomeTeamNegativeSpread ? 'bet_price_under_positive': 'bet_price_under_negative'

	const isOverMissing = betPriceOver == null || isNaN(Number(betPriceOver));
	const isUnderMissing = betPriceUnder == null || isNaN(Number(betPriceUnder));
	const displayBetPriceOver = isOverMissing ? '—' : betPriceOver;
	const displayBetPriceUnder = isUnderMissing ? '—' : betPriceUnder;

	useEffect(() => {
		const getOddsHistory = async () => {
		const split = outcome_id_normalized.split(':');
		let outcome_id_normalized_arr = [];
		
		// Add the base outcome_id_normalized with over/under sides first
		if (split[1] === 'Point Spread' || split[1] === 'Asian Handicap') {
			outcome_id_normalized_arr.push(outcome_id_normalized);
		} else if (split[1] === 'Moneyline') {
			outcome_id_normalized_arr.push(outcome_id_normalized);
		} else {
			// For non-spread/non-moneyline bets, add over and under versions of the base outcome ID
			const baseOver = `${split[0]}:${split[1]}:${split[2]}:${split[3]}:over:${split[4]}`;
			const baseUnder = `${split[0]}:${split[1]}:${split[2]}:${split[3]}:under:${split[4]}`;
			outcome_id_normalized_arr.push(baseOver);
			outcome_id_normalized_arr.push(baseUnder);
		}

			for (let i = 0; i < selectedSportsbooks.length; i++) {
				const book = selectedSportsbooks[i];
				if (split[1] === 'Point Spread' || split[1] === 'Asian Handicap') {
					const outcomeid = `${split[0]}:${split[1]}:${split[2]}:${book}`;
					outcome_id_normalized_arr.push(outcomeid);
				} else if (split[1] === 'Moneyline') {
					const outcomeid = `${split[0]}:${split[1]}:${book}`;
					outcome_id_normalized_arr.push(outcomeid);
				} else {
					// Add over and under sides for each sportsbook
					const outcomeidOver = `${split[0]}:${split[1]}:${split[2]}:${split[3]}:over:${book}`;
					const outcomeidUnder = `${split[0]}:${split[1]}:${split[2]}:${split[3]}:under:${book}`;
					outcome_id_normalized_arr.push(outcomeidOver);
					outcome_id_normalized_arr.push(outcomeidUnder);
				}
			}

			const accessToken = await getAccessTokenSilently();

			const data = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/outcomes_history?outcome_id_normalized=${outcome_id_normalized_arr}&sport=${sport}`, {
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			});

			setOddsHistories(data.data);
		};

		getOddsHistory();
	}, [outcome_id_normalized, selectedSportsbooks, isHistoryOpen]);

	return (
		<div
			style={{
				display: 'flex',
				gap: '8px',
				padding: '10px 12px',
				borderRadius: 'var(--screener-radius-sm, 8px)',
				color: 'var(--screener-text, #fff)',
				justifyContent: 'center',
				alignItems: 'center',
				width: 'fit-content',
				margin: 'auto',
			}}>
			<div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
				<Table size="small">
					<TableRow>
						<TableCell sx={{ border: 'none', padding: '4px' }}></TableCell>
						<TableCell sx={{ border: 'none', padding: '4px' }}>
							<LogoGenerator sportsbook={sportsbook} />
						</TableCell>
					</TableRow>
					<TableRow>
						<TableCell sx={{ border: 'none', padding: '4px' }}>
							{linkOver && (
								<Tooltip title="open link">
									<button onClick={() => window.open(linkOver, '_blank', 'noopener,noreferrer')} style={iconButtonStyle}>
										🔗
									</button>
								</Tooltip>
							)}
						</TableCell>
						<TableCell sx={{ border: 'none', padding: '4px' }}>
							<div
								style={{
									color: isOverMissing ? 'var(--screener-text-muted, #8b909a)' : 'white',
									fontSize: '0.8rem',
								}}>
								{displayBetPriceOver}
							</div>
						</TableCell>
					</TableRow>
					<TableRow>
						<TableCell sx={{ border: 'none', padding: '4px' }}>
							{linkUnder && (
								<Tooltip title="open link">
									<button onClick={() => window.open(linkUnder, '_blank', 'noopener,noreferrer')} style={iconButtonStyle}>
										🔗
									</button>
								</Tooltip>
							)}
						</TableCell>
						<TableCell sx={{ border: 'none', padding: '4px' }}>
							<div
								style={{
									color: isUnderMissing ? 'var(--screener-text-muted, #8b909a)' : 'white',
									fontSize: '0.8rem',
								}}>
								{displayBetPriceUnder}
							</div>
						</TableCell>
					</TableRow>
				</Table>
			</div>
			<div
				style={{
					width: 1,
					background: 'rgba(255,255,255,0.1)',
					height: '115px',
					margin: '0 8px',
				}}
			/>
			<div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
				<Tooltip title="view price history">
					<button
						onClick={(e) => {
							setIsHistoryOpen(true);
						}}
						style={iconButtonStyle}>
						📈
					</button>
				</Tooltip>
				<Modal
					open={isHistoryOpen}
					onClose={(e) => {
						setIsHistoryOpen(false);
					}}>
					<Box
						sx={{
							position: 'absolute',
							top: '50%',
							left: '50%',
							transform: 'translate(-50%, -50%) scale(0.9)',
							width: '90vw',
							height: '90vh',
							bgcolor: '#24262c',
							boxShadow: 24,
							p: 1.4,
							borderRadius: 2,
							overflow: 'auto',
						}}>
						<div>
							<Select
								defaultValue={() => (
									<div style={{ color: 'white' }} className="sportsbooks-dropdown p-1">
										Sportsbooks{' '}
										<span style={{ color: 'white', backgroundColor: '#0c62f6', borderRadius: '30px', paddingLeft: 8, paddingRight: 8, paddingTop: 4, paddingBottom: 4 }}>
											{selectedSportsbooks?.length}
										</span>
									</div>
								)}
								renderValue={() => (
									<div style={{ color: 'white' }} className="sportsbooks-dropdown p-1">
										Sportsbooks{' '}
										<span style={{ color: 'white', backgroundColor: '#0c62f6', borderRadius: '30px', paddingLeft: 8, paddingRight: 8, paddingTop: 4, paddingBottom: 4 }}>
											{selectedSportsbooks?.length}
										</span>
									</div>
								)}
								multiple
								value={selectedSportsbooks}>
								{sportsbooks.map((book) => {
									return (
										<MenuItem
											onClick={() => {
												setSelectedSportsbooks((prev) => (prev.includes(book) ? prev.filter((b) => b !== book) : [...prev, book]));
											}}
											key={book}
											value={book}
											sx={{
												backgroundColor: selectedSportsbooks.includes(book) ? 'rgba(25, 118, 210, 0.08)' : '',
											}}>
											{getSportsbookDisplayName(book)}
										</MenuItem>
									);
								})}
							</Select>
						</div>
						<OddsHistoryGraph
							oddsHistories={oddsHistories}
							split={outcome_id_normalized.split(':')}
							additionalSportsbooksToHighlight={[]}
							sportsbooksToHighlight={[]}
							setAdditionalSportsbooksToHighlight={() => {}}
							showLogo={false}
							sharpFilter={''}
							sharpBook={''}
							timeRange={selectedTimeRange}
							isMobile={true}
							setIsModalOpen={setIsHistoryOpen}
							isModalOpen={isHistoryOpen}
							selected={selectedTimeRange}
							setSelected={setSelectedTimeRange}
							overSide={!isSpread ? 'bet_price_over' : spreadOver}
							underSide={!isSpread ? 'bet_price_under' : spreadUnder}
							tutorial={false}
						/>
					</Box>
				</Modal>
			</div>
		</div>
	);
};

const iconButtonStyle = {
	backgroundColor: '#2a2a40',
	border: 'none',
	borderRadius: '8px',
	padding: '6px',
	cursor: 'pointer',
	fontSize: '14px',
	width: '32px',
	height: '32px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
};
